
import Icon from '@/ui-kit/components/icon';
import { IconType } from '@/ui-kit/components/icon/enums';
import Gutter from '@/ui-kit/components/gutter';
import Button from '@/ui-kit/components/button';
import { StyleSizeType, StyleColorSchemeType, StylePositionType } from '@/ui-kit/styles/enums';
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Container from '@/components/container';
import Content from '@/components/content';
import {
  StartPrice,
  MinMaxPrice,
} from '@/components/page-specific/buy-sell-your-home/commission-calculator-section/enums';
import { Representor } from '@/components/page-specific/commission-calculator/enums';
import RepresentorSelection from '@/components/page-specific/commission-calculator/representor-selection';
import { formatMoney } from '@/utils/utilities';
import CommissionHelper from '@/utils/commission';
import routes from '@/constants/routes';
import { PROVINCES } from '@/constants';
import Slider from '../slider';
import Table from '../table';

/**
 * @component BuyerComponent
 *
 * This component allows user to calculate savings when selling a
 * property based on pricing.
 *
 * @public
 */

export default {
  name: 'BuyerComponent',
  components: {
    Container,
    Content,
    Table,
    Slider,
    Typography,
    Button,
    Icon,
    Gutter,
    RepresentorSelection,
  },
  props: {
    slider: {
      type: Object,
      required: true,
      title: {
        type: String,
      },
      tip: {
        type: String,
      },
    },
    result: {
      type: Object,
      required: true,
      legend: {
        type: Object,
        left: {
          type: String,
        },
        right: {
          type: String,
        },
      },
      tip: {
        type: String,
      },
    },
    tableDisclaimer: {
      type: Object,
      default: () => {},
    },
    activeProvince: {
      type: String,
      default: PROVINCES.AB,
    },
  },
  data() {
    return {
      price: {
        value: StartPrice[PROVINCES.AB],
        min: MinMaxPrice.MIN,
        max: MinMaxPrice.MAX,
      },
      isAgentSelected: false,
      TypographyType,
      StyleSizeType,
      StyleColorSchemeType,
      StylePositionType,
      ButtonFillType,
      routes,
      IconType,
      Representor,
      StartPrice,
    };
  },
  computed: {
    costBodeSeller() {
      return CommissionHelper.getBodeCommission(this.price.value);
    },

    costBodeBuyer() {
      return this.isAgentSelected ? this.costAgentSeller : 0;
    },

    costAgentSeller() {
      return CommissionHelper.getBuyerCommission(this.price.value, this.activeProvince);
    },

    noteText() {
      return this.tableDisclaimer[this.activeProvince.toLowerCase()];
    },

    formattedSavings() {
      return this.isAgentSelected
        ? '$0'
        : this.format(this.costAgentSeller);
    },
  },
  mounted() {
    this.setPrice(StartPrice[this.activeProvince]);
  },
  methods: {
    setIsAgentSelected(selection) {
      this.isAgentSelected = selection !== Representor.Bode;
    },

    /**
     * Set property pricing.
     *
     * @param {Number} value
     * @private
     */

    setPrice(value) {
      this.price.value = value;
    },

    /**
     * Format number with commas as thousands separators.
     *
     * @param {Number} nb
     * @return {String}
     * @private
     */

    format(nb) {
      return formatMoney(nb);
    },

    handleFindYourHomeButtonClick() {
      this.$router.push(routes.search);
    },
  },
};
